import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Литература. 10 класс",
        subject: "Комплексный анализ литературного произведения (на примере изучения прозы  А.П. Чехова)",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Комплексный анализ литературного произведения (на примере изучения прозы  А.П. Чехова)",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Аристова Мария Александровна",
                grade: "кандидат педагогических наук, старший научный сотрудник лаборатории филологического общего образования ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<p style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>Владение комплексным филологическим анализом – одно из самых сложных умений в системе школьного литературного образования. Федеральный государственный образовательный стандарт определяет его как обязательное требование на этапе средней школы только для углублённого изучения литературы в старших классах гуманитарного профиля. Другими словами, это умение, ориентированное на последующую профессиональную подготовку ученика-гуманитария. </p>"
                        },
                        {
                            type: "block",
                            text: `<p style='padding-left: 2.4rem;'>Овладение комплексным филологическим анализом возможно в том случае, когда у обучающихся сформированы предметные и метапредметные умения, предусмотренные программой базового уровня. При этом необходимо овладение и специфическими умениями, которые определены в программе углублённого уровня. К таким умениям относятся следующие:    </p>
                                    <p style='padding-left: 2.4rem;'>
                                    <ul>
                                    <li>понимание и осмысленное использование терминологического аппарата современного литературоведения; </li>
                                    <li>сформированность умений определять и учитывать историко-культурный контекст и контекст творчества писателя, выявлять связь литературных произведений с современностью; </li>
                                    <li>сформированность представлений о стилях художественной литературы разных эпох, литературных направлениях, течениях, школах, об индивидуальном авторском стиле; </li>
                                    <li>сформированность представлений об основных направлениях литературной критики, о современных подходах к анализу художественного текста в литературоведении; умение создавать собственные литературно-критические произведения на основе прочитанных художественных текстов; </li>
                                    <li>владение умениями учебной проектно-исследовательской деятельности историко- и теоретико-литературного характера. </li>
                                    </ul>                                  
                                    </p>
                                    `
                        },
                        {
                            type: "block",
                            text: `<p style='padding-left: 2.4rem;'>Не менее важно также, чтобы сам учитель в достаточной мере владел умениями филологического анализа художественного текста, знал основные научно-теоретические подходы к нему и мог выбрать наиболее целесообразную и методически обоснованную стратегию работы с текстом на уроке.</p>
                                   `
                        },
                        {
                            type: "block",
                            text: `<p style='padding-left: 2.4rem;'>Во многом такой выбор зависит от подготовленности и интересов обучающихся, но есть и определенные научные подходы, которые также следует учитывать. Рассмотрим основные из них. </p>
                                   `
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 1",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video1.mp4",
            contentBefore: [{
                type: "text",
                text: ``
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль. Часть 1",
            htmlPath: "./interactive/dist1/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 2",
            imagePath: "",
            id: "2",
            videoUrl: "./video/video2.mp4",
            contentBefore: [{
                type: "text",
                text: ``
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 5,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1012",
            title: "Практический модуль. Часть 2",
            htmlPath: "./interactive/dist2/index.html",
            autoHeight: false
        },
        {
            order: 6,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 3",
            imagePath: "",
            id: "3",
            videoUrl: "./video/video3.mp4",
            contentBefore: [{
                type: "text",
                text: ``
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 7,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1013",
            title: "Практический модуль. Часть 3",
            htmlPath: "./interactive/dist3/index.html",
            autoHeight: false
        },
        {
            order: 8,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Аристова М.А. Формирование интерпретационных умений на уроках литературы: предметные и метапредметные результаты // Конференциум АСОУ. 2018, № 2",
                "Бабенко Л.Г. Филологический анализ текста. Основы теории, принципы и аспекты анализа. – Москва: Академический Проект; Екатеринбург: Деловая книга, 2004",
                "Багно В.Е. Миф-образ-мотив: Русская литература в контексте мировой. – Санкт-Петербург, 2014",
                "Бахтин М.М. К методологии гуманитарных наук // Бахтин М.М. Эстетика словесного творчества. – Москва: Искусство, 1979",
                "Богданова О. Ю. Методика преподавания литературы. Учебник для студ. пед. вузов / О. Ю. Богданова, С. А. Леонов, В. Ф. Чертов; под ред. О. Ю. Богдановой.  2-е изд., стер. – Москва: Издательский центр «Академия», 2002",
                "Гиршман М.М. Литературное произведение: теория и практика анализа. – Москва: Высшая школа, 1991",
                "Есин А.Б. Принципы и приемы анализа литературного произведения. – Москва: Флинта, Наука, 2005 ",
                "Катаев В.Б. Проза Чехова: проблемы интерпретации. – Москва: Изд-во МГУ, 1979",
                "Литература: реализация требований ФГОС СОО (углубленный уровень): методическое пособие для учителей / [Аристова М.А., Критарова Ж.Н., Шамчикова В.М.]; под ред. М.А. Аристовой. – Москва: ФГБНУ «Институт стратегии развития образования», 2023",
                "Литературные архетипы и универсалии: Сборник / Под ред. Е.М. Мелетинского. – Москва, 2001",
                "Николина Н.А. Филологический анализ текста: Учеб. пособие для студ. высш. пед. учеб. заведений. – Москва: Издательский центр «Академия», 2003 ",
                "Николюкин А.Н. Литературная энциклопедия терминов и понятий. – Москва: НПК «Интерван», 2001",
                "Рассадин С.Б. Невольник чести, или драматург Пушкин. – Санкт-Петербург: Гос. Пушкин. театр. центр, 2006",
                "Шанский Н.М., Махмудов Ш.А. Филологический анализ художественного текста: Пособие для студентов филол. фак. пед. вузов. СПб, 2010",

            ],
            sites: [
                "Портал популяризации культурного наследия и традиций народов России «Культура.РФ»: https://www.culture.ru/ ",
            ],
            filesToDownload: [
                {
                    link: "./files/additional.pdf",
                    fileName: "Обучение филологическому анализу лирических произведений"
                }
            ]
        }
    ],
};